
const myHolder = {
    "isLive": true,
    "isLocal": false
};

export default myHolder;
